import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

// rich text editor tiptap
import { TiptapVuetifyPlugin } from "tiptap-vuetify";
import "tiptap-vuetify/dist/main.css";

Vue.use(Vuetify);

const vuetify = new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#3C3C3B", // #Greenie Blauw: 4c49f6
				secondary: colors.cyan.lighten4, // #673AB7
				success: colors.green.lighten1, //#66BB6A
				info: colors.lightBlue.lighten1, //#29B6F6
				accent: colors.indigo.lighten1, // #5C6BC0
				warning: colors.orange,
				error: colors.red.lighten1, // #EF5350
			},
		},
	},
	icons: {
		iconfont: "md",
	},
	breakpoint: {
		mobileBreakpoint: 1025, // This is equivalent to a value of 960
	},
});

Vue.use(TiptapVuetifyPlugin, {
	vuetify,
});

export default vuetify;
